import { ROUTER_PATH } from "@config/router";
import {
  isBriefTabInShellPath,
  isInvestTabInShellPath,
  isPlanTabInShellPath,
  isTrackerTabInShellPath,
} from "@utils/bridge/shellTabPathPolicy";

export const isBriefHomePath = isBriefTabInShellPath;

export const isPlanHomePath = isPlanTabInShellPath;

const isPortfolioHomePath = (pathname: string) => {
  return pathname.startsWith(
    ROUTER_PATH.mobile.MOBILE_MAIN_TAB_ALPHA_PORTFOLIO,
  );
};

export const isInvestHomePath = isInvestTabInShellPath;

const isDiscoverHomePath = (pathname: string) => {
  return pathname.startsWith(ROUTER_PATH.mobile.MOBILE_MAIN_TAB_ALPHA_DISCOVER);
};

const isTaskHomePath = (pathname: string) => {
  return pathname.startsWith(ROUTER_PATH.mobile.MOBILE_MAIN_TAB_TASK);
};

export const isTrackerHomePath = isTrackerTabInShellPath;

export const isTableHomePath = (pathname: string) => {
  return (
    isInvestHomePath(pathname) ||
    isDiscoverHomePath(pathname) ||
    isTaskHomePath(pathname) ||
    isPortfolioHomePath(pathname) ||
    isBriefHomePath(pathname) ||
    isPlanHomePath(pathname)
  );
};
